const year = new Date().getFullYear();

export const Footer = () => {
  return (
    <footer className="w-full border-t border-border bg-background">
      <div className="px-6 py-2 sm:px-10 sm:py-3 lg:px-20">
        <div className="flex flex-col items-start gap-1.5 sm:flex-row sm:items-center sm:justify-between sm:gap-0">
          <p className="text-[13px] font-normal text-muted-foreground">© {year} Fundy — All rights reserved</p>
          <div className="flex flex-wrap items-center gap-3 sm:gap-4">
            <a
              href="/terms"
              className="rounded-sm text-[13px] font-medium text-muted-foreground underline-offset-4 transition-colors duration-150 hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            >
              Terms & Conditions
            </a>
            <a
              href="/privacy"
              className="rounded-sm text-[13px] font-medium text-muted-foreground underline-offset-4 transition-colors duration-150 hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            >
              Privacy Policy
            </a>
            <a
              href="/cookies-policy"
              className="rounded-sm text-[13px] font-medium text-muted-foreground underline-offset-4 transition-colors duration-150 hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            >
              Cookies Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
